import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateProductionItemMutationVariables = Types.Exact<{
  input: Types.CreateProductionItemInput;
}>;


export type CreateProductionItemMutation = { __typename?: 'Mutation', createProductionItem: { __typename?: 'ProductionItemPayload', productionItem?: { __typename?: 'ProductionItemStateData', tenantId: string, productionItemId: string, productionCatalogId: string, productionCategoryId: string, productionItemNumber: string, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, status: Types.ProductionItemStatus, salesItemId?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateProductionItemMutationVariables = Types.Exact<{
  input: Types.UpdateProductionItemInput;
}>;


export type UpdateProductionItemMutation = { __typename?: 'Mutation', updateProductionItem: { __typename?: 'ProductionItemPayload', productionItem?: { __typename?: 'ProductionItemStateData', tenantId: string, productionItemId: string, productionCatalogId: string, productionCategoryId: string, productionItemNumber: string, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, status: Types.ProductionItemStatus, salesItemId?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateProductionItemMutationVariables = Types.Exact<{
  input: Types.ActivateProductionItemInput;
}>;


export type ActivateProductionItemMutation = { __typename?: 'Mutation', activateProductionItem: { __typename?: 'ProductionItemPayload', productionItem?: { __typename?: 'ProductionItemStateData', tenantId: string, productionItemId: string, productionCatalogId: string, productionCategoryId: string, productionItemNumber: string, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, status: Types.ProductionItemStatus, salesItemId?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type InactivateProductionItemMutationVariables = Types.Exact<{
  input: Types.InactivateProductionItemInput;
}>;


export type InactivateProductionItemMutation = { __typename?: 'Mutation', inactivateProductionItem: { __typename?: 'ProductionItemPayload', productionItem?: { __typename?: 'ProductionItemStateData', tenantId: string, productionItemId: string, productionCatalogId: string, productionCategoryId: string, productionItemNumber: string, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, status: Types.ProductionItemStatus, salesItemId?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteProductionItemMutationVariables = Types.Exact<{
  input: Types.DeleteProductionItemInput;
}>;


export type DeleteProductionItemMutation = { __typename?: 'Mutation', deleteProductionItem: { __typename?: 'ProductionItemPayload', productionItem?: { __typename?: 'ProductionItemStateData', tenantId: string, productionItemId: string, productionCatalogId: string, productionCategoryId: string, productionItemNumber: string, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, status: Types.ProductionItemStatus, salesItemId?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetItemLaborCostMutationVariables = Types.Exact<{
  input: Types.SetItemLaborCostInput;
}>;


export type SetItemLaborCostMutation = { __typename?: 'Mutation', setItemLaborCost: { __typename?: 'ProductionItemPayload', productionItem?: { __typename?: 'ProductionItemStateData', tenantId: string, productionItemId: string, productionCatalogId: string, productionCategoryId: string, productionItemNumber: string, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, status: Types.ProductionItemStatus, salesItemId?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearItemLaborCostMutationVariables = Types.Exact<{
  input: Types.ClearItemLaborCostInput;
}>;


export type ClearItemLaborCostMutation = { __typename?: 'Mutation', clearItemLaborCost: { __typename?: 'ProductionItemPayload', productionItem?: { __typename?: 'ProductionItemStateData', tenantId: string, productionItemId: string, productionCatalogId: string, productionCategoryId: string, productionItemNumber: string, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, status: Types.ProductionItemStatus, salesItemId?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ProductionItemLinkResultFragment = { __typename?: 'ProductionItemLinkResult', productionItemId: string, status: Types.ProductionItemLinkResultStatus, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null };

export type LinkProductionItemsToSalesItemMutationVariables = Types.Exact<{
  input: Types.LinkProductionItemsToSalesItemInput;
}>;


export type LinkProductionItemsToSalesItemMutation = { __typename?: 'Mutation', linkProductionItemsToSalesItem: { __typename?: 'LinkProductionItemsToSalesItemPayload', productionItems: Array<{ __typename?: 'ProductionItemStateData', tenantId: string, productionItemId: string, productionCatalogId: string, productionCategoryId: string, productionItemNumber: string, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, status: Types.ProductionItemStatus, salesItemId?: string | null }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, results: Array<{ __typename?: 'ProductionItemLinkResult', productionItemId: string, status: Types.ProductionItemLinkResultStatus, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }> } };

export type UnlinkProductionItemsFromSalesItemMutationVariables = Types.Exact<{
  input: Types.UnlinkProductionItemsFromSalesItemInput;
}>;


export type UnlinkProductionItemsFromSalesItemMutation = { __typename?: 'Mutation', unlinkProductionItemsFromSalesItem: { __typename?: 'LinkProductionItemsToSalesItemPayload', productionItems: Array<{ __typename?: 'ProductionItemStateData', tenantId: string, productionItemId: string, productionCatalogId: string, productionCategoryId: string, productionItemNumber: string, laborCostPerUnit?: number | null, laborCostEffectiveDate?: Types.TDateISO | null, status: Types.ProductionItemStatus, salesItemId?: string | null }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, results: Array<{ __typename?: 'ProductionItemLinkResult', productionItemId: string, status: Types.ProductionItemLinkResultStatus, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }> } };

export type CombineProductionItemsMutationVariables = Types.Exact<{
  input: Types.CombineProductionItemsInput;
}>;


export type CombineProductionItemsMutation = { __typename?: 'Mutation', combineProductionItems: { __typename?: 'CombineProductionItemsPayload', survivorId?: string | null, loserId?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RevertProductionItemCombineMutationVariables = Types.Exact<{
  input: Types.RevertProductionItemCombineInput;
}>;


export type RevertProductionItemCombineMutation = { __typename?: 'Mutation', revertProductionItemCombine: { __typename?: 'RevertProductionItemCombinePayload', survivorId?: string | null, loserId?: string | null, forecastSalesItemIdsNotRestored?: Array<string> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type LinkProductionItemsToSalesItemsMutationVariables = Types.Exact<{
  input: Types.LinkProductionItemsToSalesItemsInput;
}>;


export type LinkProductionItemsToSalesItemsMutation = { __typename?: 'Mutation', linkProductionItemsToSalesItems: { __typename?: 'LinkProductionItemsToSalesItemsPayload', results: Array<{ __typename?: 'ProductionItemLinkPairResult', rowIndex: number, productionItemId?: string | null, productionItemNumber?: string | null, salesItemId?: string | null, salesItemCode?: string | null, salesItemName?: string | null, currentSalesItemId?: string | null, currentSalesItemName?: string | null, outcome: Types.ProductionItemLinkPairOutcome, reason?: string | null }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UnlinkProductionItemGridRowsMutationVariables = Types.Exact<{
  input: Types.UnlinkProductionItemsFromSalesItemInput;
}>;


export type UnlinkProductionItemGridRowsMutation = { __typename?: 'Mutation', unlinkProductionItemsFromSalesItem: { __typename?: 'LinkProductionItemsToSalesItemPayload', results: Array<{ __typename?: 'ProductionItemLinkResult', productionItemId: string, status: Types.ProductionItemLinkResultStatus, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export const ProductionItemLinkResultFragmentDoc = new TypedDocumentString(`
    fragment ProductionItemLinkResult on ProductionItemLinkResult {
  productionItemId
  status
  errors {
    code
    message
  }
}
    `, {"fragmentName":"ProductionItemLinkResult"});
export const CreateProductionItemDocument = new TypedDocumentString(`
    mutation CreateProductionItem($input: CreateProductionItemInput!) {
  createProductionItem(input: $input) {
    productionItem {
      ...ProductionItemData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionItemData on ProductionItemStateData {
  tenantId
  productionItemId
  productionCatalogId
  productionCategoryId
  productionItemNumber
  laborCostPerUnit
  laborCostEffectiveDate
  status
  salesItemId
}`);
export const UpdateProductionItemDocument = new TypedDocumentString(`
    mutation UpdateProductionItem($input: UpdateProductionItemInput!) {
  updateProductionItem(input: $input) {
    productionItem {
      ...ProductionItemData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionItemData on ProductionItemStateData {
  tenantId
  productionItemId
  productionCatalogId
  productionCategoryId
  productionItemNumber
  laborCostPerUnit
  laborCostEffectiveDate
  status
  salesItemId
}`);
export const ActivateProductionItemDocument = new TypedDocumentString(`
    mutation ActivateProductionItem($input: ActivateProductionItemInput!) {
  activateProductionItem(input: $input) {
    productionItem {
      ...ProductionItemData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionItemData on ProductionItemStateData {
  tenantId
  productionItemId
  productionCatalogId
  productionCategoryId
  productionItemNumber
  laborCostPerUnit
  laborCostEffectiveDate
  status
  salesItemId
}`);
export const InactivateProductionItemDocument = new TypedDocumentString(`
    mutation InactivateProductionItem($input: InactivateProductionItemInput!) {
  inactivateProductionItem(input: $input) {
    productionItem {
      ...ProductionItemData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionItemData on ProductionItemStateData {
  tenantId
  productionItemId
  productionCatalogId
  productionCategoryId
  productionItemNumber
  laborCostPerUnit
  laborCostEffectiveDate
  status
  salesItemId
}`);
export const DeleteProductionItemDocument = new TypedDocumentString(`
    mutation DeleteProductionItem($input: DeleteProductionItemInput!) {
  deleteProductionItem(input: $input) {
    productionItem {
      ...ProductionItemData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionItemData on ProductionItemStateData {
  tenantId
  productionItemId
  productionCatalogId
  productionCategoryId
  productionItemNumber
  laborCostPerUnit
  laborCostEffectiveDate
  status
  salesItemId
}`);
export const SetItemLaborCostDocument = new TypedDocumentString(`
    mutation SetItemLaborCost($input: SetItemLaborCostInput!) {
  setItemLaborCost(input: $input) {
    productionItem {
      ...ProductionItemData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionItemData on ProductionItemStateData {
  tenantId
  productionItemId
  productionCatalogId
  productionCategoryId
  productionItemNumber
  laborCostPerUnit
  laborCostEffectiveDate
  status
  salesItemId
}`);
export const ClearItemLaborCostDocument = new TypedDocumentString(`
    mutation ClearItemLaborCost($input: ClearItemLaborCostInput!) {
  clearItemLaborCost(input: $input) {
    productionItem {
      ...ProductionItemData
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionItemData on ProductionItemStateData {
  tenantId
  productionItemId
  productionCatalogId
  productionCategoryId
  productionItemNumber
  laborCostPerUnit
  laborCostEffectiveDate
  status
  salesItemId
}`);
export const LinkProductionItemsToSalesItemDocument = new TypedDocumentString(`
    mutation LinkProductionItemsToSalesItem($input: LinkProductionItemsToSalesItemInput!) {
  linkProductionItemsToSalesItem(input: $input) {
    productionItems {
      ...ProductionItemData
    }
    errors {
      code
      message
    }
    results {
      ...ProductionItemLinkResult
    }
  }
}
    fragment ProductionItemLinkResult on ProductionItemLinkResult {
  productionItemId
  status
  errors {
    code
    message
  }
}
fragment ProductionItemData on ProductionItemStateData {
  tenantId
  productionItemId
  productionCatalogId
  productionCategoryId
  productionItemNumber
  laborCostPerUnit
  laborCostEffectiveDate
  status
  salesItemId
}`);
export const UnlinkProductionItemsFromSalesItemDocument = new TypedDocumentString(`
    mutation UnlinkProductionItemsFromSalesItem($input: UnlinkProductionItemsFromSalesItemInput!) {
  unlinkProductionItemsFromSalesItem(input: $input) {
    productionItems {
      ...ProductionItemData
    }
    errors {
      code
      message
    }
    results {
      ...ProductionItemLinkResult
    }
  }
}
    fragment ProductionItemLinkResult on ProductionItemLinkResult {
  productionItemId
  status
  errors {
    code
    message
  }
}
fragment ProductionItemData on ProductionItemStateData {
  tenantId
  productionItemId
  productionCatalogId
  productionCategoryId
  productionItemNumber
  laborCostPerUnit
  laborCostEffectiveDate
  status
  salesItemId
}`);
export const CombineProductionItemsDocument = new TypedDocumentString(`
    mutation CombineProductionItems($input: CombineProductionItemsInput!) {
  combineProductionItems(input: $input) {
    survivorId
    loserId
    errors {
      code
      message
    }
  }
}
    `);
export const RevertProductionItemCombineDocument = new TypedDocumentString(`
    mutation RevertProductionItemCombine($input: RevertProductionItemCombineInput!) {
  revertProductionItemCombine(input: $input) {
    survivorId
    loserId
    forecastSalesItemIdsNotRestored
    errors {
      code
      message
    }
  }
}
    `);
export const LinkProductionItemsToSalesItemsDocument = new TypedDocumentString(`
    mutation LinkProductionItemsToSalesItems($input: LinkProductionItemsToSalesItemsInput!) {
  linkProductionItemsToSalesItems(input: $input) {
    results {
      ...ProductionItemLinkPairResult
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionItemLinkPairResult on ProductionItemLinkPairResult {
  rowIndex
  productionItemId
  productionItemNumber
  salesItemId
  salesItemCode
  salesItemName
  currentSalesItemId
  currentSalesItemName
  outcome
  reason
}`);
export const UnlinkProductionItemGridRowsDocument = new TypedDocumentString(`
    mutation UnlinkProductionItemGridRows($input: UnlinkProductionItemsFromSalesItemInput!) {
  unlinkProductionItemsFromSalesItem(input: $input) {
    results {
      ...ProductionItemLinkResult
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionItemLinkResult on ProductionItemLinkResult {
  productionItemId
  status
  errors {
    code
    message
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateProductionItem: build.mutation<CreateProductionItemMutation, CreateProductionItemMutationVariables>({
      query: (variables) => ({ document: CreateProductionItemDocument, variables })
    }),
    UpdateProductionItem: build.mutation<UpdateProductionItemMutation, UpdateProductionItemMutationVariables>({
      query: (variables) => ({ document: UpdateProductionItemDocument, variables })
    }),
    ActivateProductionItem: build.mutation<ActivateProductionItemMutation, ActivateProductionItemMutationVariables>({
      query: (variables) => ({ document: ActivateProductionItemDocument, variables })
    }),
    InactivateProductionItem: build.mutation<InactivateProductionItemMutation, InactivateProductionItemMutationVariables>({
      query: (variables) => ({ document: InactivateProductionItemDocument, variables })
    }),
    DeleteProductionItem: build.mutation<DeleteProductionItemMutation, DeleteProductionItemMutationVariables>({
      query: (variables) => ({ document: DeleteProductionItemDocument, variables })
    }),
    SetItemLaborCost: build.mutation<SetItemLaborCostMutation, SetItemLaborCostMutationVariables>({
      query: (variables) => ({ document: SetItemLaborCostDocument, variables })
    }),
    ClearItemLaborCost: build.mutation<ClearItemLaborCostMutation, ClearItemLaborCostMutationVariables>({
      query: (variables) => ({ document: ClearItemLaborCostDocument, variables })
    }),
    LinkProductionItemsToSalesItem: build.mutation<LinkProductionItemsToSalesItemMutation, LinkProductionItemsToSalesItemMutationVariables>({
      query: (variables) => ({ document: LinkProductionItemsToSalesItemDocument, variables })
    }),
    UnlinkProductionItemsFromSalesItem: build.mutation<UnlinkProductionItemsFromSalesItemMutation, UnlinkProductionItemsFromSalesItemMutationVariables>({
      query: (variables) => ({ document: UnlinkProductionItemsFromSalesItemDocument, variables })
    }),
    CombineProductionItems: build.mutation<CombineProductionItemsMutation, CombineProductionItemsMutationVariables>({
      query: (variables) => ({ document: CombineProductionItemsDocument, variables })
    }),
    RevertProductionItemCombine: build.mutation<RevertProductionItemCombineMutation, RevertProductionItemCombineMutationVariables>({
      query: (variables) => ({ document: RevertProductionItemCombineDocument, variables })
    }),
    LinkProductionItemsToSalesItems: build.mutation<LinkProductionItemsToSalesItemsMutation, LinkProductionItemsToSalesItemsMutationVariables>({
      query: (variables) => ({ document: LinkProductionItemsToSalesItemsDocument, variables })
    }),
    UnlinkProductionItemGridRows: build.mutation<UnlinkProductionItemGridRowsMutation, UnlinkProductionItemGridRowsMutationVariables>({
      query: (variables) => ({ document: UnlinkProductionItemGridRowsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateProductionItemMutation, useUpdateProductionItemMutation, useActivateProductionItemMutation, useInactivateProductionItemMutation, useDeleteProductionItemMutation, useSetItemLaborCostMutation, useClearItemLaborCostMutation, useLinkProductionItemsToSalesItemMutation, useUnlinkProductionItemsFromSalesItemMutation, useCombineProductionItemsMutation, useRevertProductionItemCombineMutation, useLinkProductionItemsToSalesItemsMutation, useUnlinkProductionItemGridRowsMutation } = injectedRtkApi;
